module.exports = __webpack_public_path__ + "static/media/refundIcon.9d5f79f0.svg";